import React from 'react';
import {FontAwesomeIcon, type FontAwesomeIconProps} from '@fortawesome/react-fontawesome';
import {ICONS, type IconName} from '@/shared/icons/registry';

export type {IconName};

export interface IconProps extends Omit<FontAwesomeIconProps, 'icon'> {
    name: IconName;
}

/**
 * Project icon wrapper over FontAwesome Pro. Reference glyphs by
 * semantic name (see `shared/icons/registry.ts`). Accepts all
 * FontAwesomeIcon props (`className`, `spin`, `size`, `fixedWidth`, …);
 * Tailwind h/w utility classes size the SVG the same way Lucide did.
 */
const Icon: React.FC<IconProps> = ({name, ...props}) => (
    <FontAwesomeIcon icon={ICONS[name]} {...props} />
);

export default Icon;
